import { Descriptions, Table, Tag } from "antd";
export const workflowKinds: Record<string, string> = {
  PURCHASE_ORDER: "采购审核",
  PAYMENT_ORDER: "付款审核",
  LOW_PRICE_SALE: "低价销售",
  STOCK_CHECK: "盘点差异 / 报损",
  PRODUCTION_EXCESS: "生产超领",
  QUALITY_CONCESSION: "质量让步",
};
export const workflowLabels: Record<string, string> = {
  DRAFT: "草稿",
  ACTIVE: "已启用",
  RETIRED: "已停用",
  PENDING: "待审批",
  WAITING: "未到本节点",
  APPROVED: "已通过",
  REJECTED: "已驳回",
  WITHDRAWN: "已撤回",
  CONSUMED: "已执行",
  CANCELLED: "已终止",
  SUBMIT: "提交申请",
  APPROVE: "同意",
  REJECT: "驳回",
  WITHDRAW: "撤回",
  TRANSFER: "转交审批",
  EXECUTED: "执行业务",
};
export const workflowStatus = (value: string) => (
  <Tag
    color={
      value === "APPROVED" || value === "CONSUMED"
        ? "green"
        : value === "REJECTED"
          ? "red"
          : value === "PENDING"
            ? "blue"
            : "default"
    }
  >
    {workflowLabels[value] ?? value}
  </Tag>
);
const labels: Record<string, string> = {
  number: "单据号",
  partner_name: "往来单位",
  order_date: "订单日期",
  due_date: "约定日期",
  business_date: "业务日期",
  businessDate: "业务日期",
  quantity: "数量",
  actualQuantity: "实盘数量",
  unit_price: "单价",
  unitCost: "盘盈参考单价",
  tax_rate: "税率",
  amount: "金额",
  total_amount: "含税总额",
  reference_sale_price: "销售参考价",
  purchase_price: "采购参考价",
  code: "商品编码",
  name: "名称",
  remark: "备注",
  reason: "业务依据",
  batchNo: "批次",
  batch_no: "批次",
  status: "状态",
  audit_status: "审核状态",
  locked_quantity: "占用数量",
  unit_cost: "库存单位成本",
  planned_quantity: "计划数量",
  material_cost: "材料成本",
  required_quantity: "需求数量",
  issued_equivalent: "已领折算量",
  allowExcess: "申请超领",
  action: "业务动作",
  open_quantity: "未解决数量",
  inspection_no: "检验单号",
  result: "检验结果",
  scope: "检验范围",
  account_name: "付款账户",
  source_no: "核销来源单号",
};
const hidden = (key: string) =>
  /(^id$|_id$|Id$|version$|alternatives$)/.test(key);
const show = (value: unknown): string =>
  value === null || value === undefined
    ? "—"
    : typeof value === "boolean"
      ? value
        ? "是"
        : "否"
      : typeof value === "object"
        ? JSON.stringify(value)
        : (workflowLabels[String(value)] ?? String(value));
export function WorkflowSnapshot({ data }: { data: Record<string, unknown> }) {
  return (
    <div className="workflow-snapshot">
      {Object.entries(data).map(([key, value]) => {
        if (Array.isArray(value)) {
          const rows = value.filter(
            (v) => v && typeof v === "object",
          ) as Record<string, unknown>[];
          const keys = [
            ...new Set(rows.flatMap((row) => Object.keys(row))),
          ].filter((k) => !hidden(k));
          return (
            <section key={key}>
              <h3>{labels[key] ?? key}</h3>
              <Table
                size="small"
                pagination={rows.length > 20 ? { pageSize: 20 } : false}
                dataSource={rows.map((row, i) => ({ ...row, _key: i }))}
                rowKey="_key"
                scroll={{ x: Math.max(650, keys.length * 125) }}
                columns={keys.map((k) => ({
                  title: labels[k] ?? k,
                  dataIndex: k,
                  width: 125,
                  render: show,
                }))}
              />
            </section>
          );
        }
        if (value && typeof value === "object") {
          const entries = Object.entries(
            value as Record<string, unknown>,
          ).filter(([k, v]) => !hidden(k) && !Array.isArray(v));
          const nested = Object.fromEntries(
            Object.entries(value as Record<string, unknown>).filter(([, v]) =>
              Array.isArray(v),
            ),
          );
          return (
            <section key={key}>
              <h3>{labels[key] ?? key}</h3>
              <Descriptions
                bordered
                size="small"
                column={2}
                items={entries.map(([k, v]) => ({
                  key: k,
                  label: labels[k] ?? k,
                  children: show(v),
                }))}
              />
              {Object.keys(nested).length > 0 && (
                <WorkflowSnapshot data={nested} />
              )}
            </section>
          );
        }
        return (
          <p key={key}>
            <strong>{labels[key] ?? key}：</strong>
            {show(value)}
          </p>
        );
      })}
    </div>
  );
}
